import {Directive, ElementRef, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {FrequentlyAskedQuestion} from './frequently-asked-question';
import {FrequentlyAskedQuestionsService} from '../frequently-asked-questions.service';
import {Results} from '../../core/results';
declare var $: any;
@Directive({
  selector: '[appFrequentlyAskedQuestion]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FrequentlyAskedQuestionDirective),
    multi: true
  }]
})
export class FrequentlyAskedQuestionDirective implements ControlValueAccessor, OnInit {

  @Input() private frequentlyAskedQuestion: FrequentlyAskedQuestion;
  @Input() private disabled = false;
  select2: any;

  constructor(private el: ElementRef, private service: FrequentlyAskedQuestionsService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: 'Frequently Asked Question',
      allowClear: true,
      ajax: {
        transport: function(params, success, failure) {
          const page = 1;
          const perPage = 10;

          that.service.search(page, perPage, 'ASC', 'name', params.data.term).subscribe((ret: Results<FrequentlyAskedQuestion>) => {
            success(ret);
          });

        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.content.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.question,
            });
          });
          return {
            results: arr
          };
        }
      }
    });
    $(this.el.nativeElement).on('select2:select', function(e) {

      that.frequentlyAskedQuestion = JSON.parse(e.params.data.id);
      that.propagateChange(that.frequentlyAskedQuestion);

    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {

      that.frequentlyAskedQuestion = null;
      that.propagateChange(that.frequentlyAskedQuestion);
    });


  }

  onTouched = () => {
  };

  propagateChange = (_: any) => {
  };

  writeValue(frequentlyAskedQuestion: FrequentlyAskedQuestion): void {

    this.frequentlyAskedQuestion = frequentlyAskedQuestion;
    this.propagateChange(this.frequentlyAskedQuestion);
    const that = this;
    if (this.frequentlyAskedQuestion !== undefined && this.frequentlyAskedQuestion !== null) {
      const option = new Option(frequentlyAskedQuestion.question, JSON.stringify(frequentlyAskedQuestion), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.frequentlyAskedQuestion;
  }

  set value(v: any) {
    if (v !== this.frequentlyAskedQuestion) {
      this.frequentlyAskedQuestion = v;
      this.propagateChange(v);
    }
  }


}
